import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { publicAssetUrl } from "@/shared/lib/publicAssetUrl"

export type NavbarBrandProps = {
  transparent: boolean
}

export const NavbarBrand = ({ transparent }: NavbarBrandProps) => {
  const { t } = useTranslation()
  return (
    <Link to="/" className="flex items-center shrink-0 hover:opacity-80 transition-opacity" aria-label={t("common.brandFull")}>
      <img
        src={publicAssetUrl("images/rgb-logo.svg")}
        alt={t("common.brandFull")}
        className={`h-8 md:h-10 w-auto transition-all duration-500 ${
          transparent ? "brightness-0 invert drop-shadow-md" : ""
        }`}
      />
    </Link>
  )
}
